import { render, staticRenderFns } from "./center2.vue?vue&type=template&id=d358dcb4&scoped=true&"
import script from "./center2.vue?vue&type=script&lang=js&"
export * from "./center2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d358dcb4",
  null
  
)

export default component.exports